'use client'

import s from './page.module.scss';
import main from '../../common/assets/images/solutions/axle-load-monitoring/axle-load-monitoring-main.webp';
import {Container} from "@/app/[locale]/common/components/Container/Container";
import {Breadcrumbs} from "@/app/[locale]/common/components/Breadcrumbs/Breadcrumbs";
import Image from "next/image";
import {Title} from "@/app/[locale]/common/components/Title/Title";
import {
    AdvantagesDisadvantagesCard
} from "@/app/[locale]/common/components/AdvantagesDisadvantagesCard/AdvantagesDisadvantagesCard";
import {ContactUs} from "@/app/[locale]/common/components/ContactUs/ContactUs";
import axle_load_gnom from '@/app/[locale]/common/assets/images/solutions/axle-load-monitoring/axle-load-monitoring-gnom.webp';
import axle_load_sensor_installation from '@/app/[locale]/common/assets/images/solutions/axle-load-monitoring/axle-load-sensor-installation.webp';
import axle_load_can_bus from '@/app/[locale]/common/assets/images/solutions/fuel-consumption-monitoring/can-bus.webp';
import {ELEMENT_INDEX} from "../../common/constants/app";
import {ParagraphLine} from "@/app/[locale]/common/components/ParagraphLine/ParagraphLine";
import {useTranslations} from "next-intl";

export default function AxleLoadMonitoringPage() {
    const t = useTranslations('AxleLoadMonitoringPage');

    return (
        <div className={s.axleLoad}>
            <Container>
                <Breadcrumbs crumb={[t.raw('breadcrumbs.SOLUTIONS'), t.raw('breadcrumbs.AXLE_LOAD_MONITORING')]} />
                <Title title={t('title')} />
                <div className={`${s.axleLoad_imageContainer} ${s.axleLoad_top}`}>
                    <Image src={main} alt={'main'} />
                </div>

                <div className={s.axleLoad_methods}>
                    <Title title={t('methodsBlock.title')} />
                    <p className={s.axleLoad_title}>{ t('methodsBlock.firstBlock.title') }</p>

                    <div className={`${s.axleLoad_methods_gnom} ${s.axleLoad_flexContainer}`}>
                        <div className={`${s.axleLoad_imageContainer} ${s.axleLoad_methods_gnom_imageContainer}`}>
                            <Image src={axle_load_gnom} alt={'axle_load_gnom'} />
                        </div>
                        <div className={s.axleLoad_methods_gnom_content}>
                            {
                                t.raw('methodsBlock.firstBlock.list').map((item: string, index: number) => (
                                    <>
                                    {
                                        index === ELEMENT_INDEX.THIRD ?
                                            <ParagraphLine key={index} className={s.axleLoad_text}>{item}</ParagraphLine>
                                            : <p key={index} className={s.axleLoad_text}>{item}</p>
                                    }
                                    </>
                                ))
                            }
                        </div>
                    </div>

                    <div className={`${s.axleLoad_imageContainer} ${s.axleLoad_methods_imageContainer}`}>
                        <Image src={axle_load_sensor_installation} alt={'axle_load_sensor_installation'} />
                    </div>


                    <AdvantagesDisadvantagesCard
                        DISADVANTAGES={t.raw('methodsBlock.firstBlock.cardDisadvantages')}
                        ADVANTAGES={t.raw('methodsBlock.firstBlock.cardAdvantages')}
                    />

                    <p className={s.axleLoad_title}>{ t('methodsBlock.secondBlock.title') }</p>

                    <div className={`${s.axleLoad_methods_canBus} ${s.axleLoad_flexContainer}`}>
                        <div className={s.axleLoad_methods_canBus_content}>
                            {
                                t.raw('methodsBlock.secondBlock.list').map((item: string, index: number) => (
                                    <p key={index} className={s.axleLoad_text}>{ item }</p>
                                ))
                            }
                        </div>

                        <div className={`${s.axleLoad_imageContainer} ${s.axleLoad_methods_canBus_imageContainer}`}>
                            <Image src={axle_load_can_bus} alt={'axle_load_can_bus'} />
                        </div>
                    </div>


                    <AdvantagesDisadvantagesCard
                        DISADVANTAGES={t.raw('methodsBlock.secondBlock.cardDisadvantages')}
                        ADVANTAGES={t.raw('methodsBlock.secondBlock.cardAdvantages')}
                    />
                </div>

                <ContactUs />
            </Container>
        </div>
    );
};